// extracted by mini-css-extract-plugin
module.exports = {"Root":"Login_Root___OasI","Lead":"Login_Lead__utL2x"};